<script>

import {mapState} from "vuex";

export default {
    name: "",
    data: () => ({}),
    methods: {

        /**
         * Zwraca tłumaczenie w wybranym języku na podstawie nazwy systemowej
         * @param code nazwa systemowa tłumaczenia
         */
        t(code) {

            let lang = this.lang;

            let lang_arr = this.lang_arr;

            let lang_none = `${code}: ${lang}`;

            let has_lang = lang_arr[lang] !== undefined;

            let has_lang_column = has_lang && lang_arr[lang][code] !== undefined && lang_arr[lang][code] !== "";

            return (has_lang && has_lang_column) ? lang_arr[lang][code] : lang_none

        },

        /**
         * Zwraca tlumaczenie kolumny w obiekcie na podstawie ustawionego języka
         *
         * @param object obiekt
         * @param column kolumna w obiekcie
         */
        to(object, column) {

            let lang = this.lang;

            let lang_none = `column "${column}" not found: ${lang}`;

            let ret = object[column] ? object[column] : lang_none;

            let texts = object["langs"];

            let has_text = texts !== undefined;

            let has_lang = has_text && texts[lang] !== undefined;

            let has_column = has_lang && texts[lang][column] !== undefined;

            let has_value = has_text && has_lang && has_column;

            ret = has_value ? texts[lang][column] : ret;

            return ret
        }
    },
    computed: {
        /**
         * Dołączanie zmiennych z VUEX'a
         */
        ...mapState({
            lang: state => state.app.lang,
            lang_arr: state => state.app.lang_arr
        })
    }
}
</script>
